import React from 'react'
import { Platform, StyleSheet, ViewProps } from 'react-native'
import { LinearGradient, LinearGradientProps } from 'expo-linear-gradient'
import { colors } from '@ui/colors'
import { twMerge } from 'tailwind-merge'
import Animated, { AnimatedProps } from 'react-native-reanimated'
import { BlurView, BlurViewProps } from 'expo-blur'
import { hex } from '@ui/utils/hex'
import { GradientType } from '@ui/types'
import Border from '@ui/effects/Border'

export type GlassProps = {
  border?: {
    borderWidth?: number
    borderColor?: string
    borderRadius?: number
  }
  gradient?: GradientType
  children: React.ReactNode
  className?: string
  blur?: number
  tint?: BlurViewProps['tint']
  gradientProps?: Partial<LinearGradientProps>
}

const defaultGradient = [
  colors.white25,
  colors.white75,
  colors.white,
  colors.white,
  colors.white75,
  colors.white25,
] satisfies GradientType

const Glass = ({
  gradient = defaultGradient,
  children,
  className,
  style,
  blur,
  tint,
  border = { borderWidth: 1, borderColor: colors.white50, borderRadius: 32 },
  gradientProps,
  ...props
}: GlassProps & AnimatedProps<ViewProps>) => {
  const borderRadius = border.borderRadius
  return (
    <Animated.View
      {...props}
      style={[{ borderRadius }, style]}
      className={twMerge('relative overflow-hidden', className)}
    >
      {!!blur && (
        <BlurView
          tint={tint}
          intensity={blur}
          style={StyleSheet.absoluteFill}
        />
      )}
      <LinearGradient
        colors={gradient}
        style={StyleSheet.absoluteFill}
        {...gradientProps}
      />
      {children}
      <Border style={{ ...border }} />
    </Animated.View>
  )
}

export default Glass
